module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-BookItalic.b97da97b.woff";